import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import {
    CodeBlock, BlockType, SettingType, ValidationMessage, ValidationMessageType,
} from '@appblocks/codegeneration/types';
import Features from '@appblocks/codegeneration/Features';
import FeatureUtils from '@appblocks/codegeneration/FeatureUtils';

export default class Tibbit_46 extends BaseTibbit {
    constructor(tibbit_id: string) {
        super();
        this.id = tibbit_id;
        this.linkedFeature = 'cell';
        this.name = 'Tibbit 46';
    }

    validate(): Array<ValidationMessage> {
        const { project } = this;
        let cellular = project.getFeature('cell');
        const messages: Array<ValidationMessage> = [];
        if (cellular === undefined) {
            cellular = FeatureUtils.getCodeItem('cell', project);
            cellular.initSettings(project);
            messages.push({
                messageType: ValidationMessageType.ADD,
                message: '',
                data: FeatureUtils.toJson(cellular),
            });
        }
        if (cellular.getSettingValue('ENABLED') !== '1') {
            messages.push({
                messageType: ValidationMessageType.UPDATE,
                message: '',
                featureId: cellular.getID(),
                settingId: 'ENABLED',
                data: '1',
            });
        }

        return messages;
    }
}
